'use client';

import { env } from '@veranda/shared/lib';
import Script from 'next/script';

// Global flag to prevent multiple event dispatches
declare global {
  interface Window {
    _klaviyoInitialized?: boolean;
    _klaviyoLoadTimeout?: number;
  }
}

export function KlaviyoScript() {
  return (
    <Script
      strategy="lazyOnload"
      id="klaviyo-on-site-tracking"
      src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${env.NEXT_PUBLIC_KLAVIYO_PUBLIC_KEY}`}
      onLoad={() => {
        // Clear timeout if it exists
        if (window._klaviyoLoadTimeout) {
          clearTimeout(window._klaviyoLoadTimeout);
        }

        // Only dispatch if not already initialized
        if (!window._klaviyoInitialized && window._learnq) {
          window._klaviyoInitialized = true;
          // Create a non-bubbling, non-cancelable event
          window.dispatchEvent(
            new CustomEvent('klaviyoReady', {
              bubbles: false,
              cancelable: false,
            })
          );
        }
      }}
      onError={() => {
        if (window._klaviyoLoadTimeout) {
          clearTimeout(window._klaviyoLoadTimeout);
        }
      }}
    />
  );
}
